/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import { useHistory } from "react-router-dom"
import { useSkeem } from "../providers/SkeemProvider"
import { Modal, useInterval } from "@cd2/components"
import { TextGroupWithActions } from "./Title"
import { IRecord } from "../types/schema"

export function AutoLogoutWhenKicked({ onAutoLogout }: { onAutoLogout(): void }) {
  const skeem = useSkeem()
  const history = useHistory()

  useInterval(async () => {
    if (!skeem.currentSession.id) {
      return
    }

    const me = await skeem.fetchMe<IRecord<"skeem_users", "isAnonymous" | "isLeaver">>([
      "isAnonymous",
      "isLeaver",
    ])

    if (me.isAnonymous || me.isLeaver) {
      onAutoLogout()
      history.push("/logout")
    }
  }, 30000)

  return null
}

AutoLogoutWhenKicked.Modal = ({ open, onClose }: { open: boolean; onClose(): void }) => (
  <Modal
    onRequestClose={onClose}
    isOpen={open}
    width={600}
    css={css("max-width: calc(100% - 20px)")}
    render={() => (
      <TextGroupWithActions
        size="medium"
        actions={[{ children: "Ok", onClick: onClose }]}
        heading="Removed from Company"
        body="You have been removed from your company account on the platform. Please contact your company's administrator if you think this was a mistake."
      />
    )}
  />
)
